import {DownloadOutlined} from '@ant-design/icons';
import {Button, Col, Form, Row, Select, Spin, Table, Typography,} from 'antd';
import axios from "axios";
import React, {Component} from 'react';
import cookie from "react-cookies";
import {connect} from "react-redux";
import '../asset/style/custom_antd_table_style.css';
import {updateUrlStateInReducer} from '../redux_actions/search.case.action';

import querystring from "query-string";
import {getCaseIdPlaceholder} from 'utils/org_utils';
import {get, post} from "../helper/request";
import {getStateAwareUrl} from "../utils/utils";
import {aclPermissions, hasPermissions} from "../const/ACLPermissions";
import {AuthHeader} from "../configs/auth.token";

const {Column} = Table;
const Option = Select.Option;
const {Title} = Typography;


class SummaryView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: this.props.urlState.search,
            initializationDone: false,
            validationIds: [],
            validatonSummary: [],
            pathologistSummary: [],
            validationName: '',
            download_user_id: cookie.load('user_id'),
            all_users: [],
        }
        this.is_clia_staff = hasPermissions([aclPermissions.clia_staff])
        this.props.dispatch(updateUrlStateInReducer(this.props.urlState));
    }

    componentWillMount() {
        this.getValidationIDs();
        this.getValidationSummary();
        this.getPathologistSummary();
        this.getValidationData(this.props.match.params.id);
        this.getAllUsers();
    }

    getAllUsers = () => {
        const url = `/api/user/?only_usernames=true`;
        get(url)
            .then(data => {
                this.setState({
                    all_users: data,
                })
            })
    }

    getValidationData = (id) => {
        let url = `/api/get_validation_data/?id=${this.props.match.params.id}`;
        get(url)
            .then(data => {
                this.setState({
                    validationName: data['name'],
                })
            })
    }


    getValidationSummary = () => {
        let url = `/api/fetch_validation_summary/?id=${this.props.match.params.id}`;
        get(url)
            .then(data => {
                this.setState({validatonSummary: data["result"]})
            })
    }

    getPathologistSummary = () => {
        let url = `/api/pathologist_agreement/?id=${this.props.match.params.id}`;
        get(url)
            .then(data => {
                this.setState({pathologistSummary: data["result"]})
            })
    }

    initializeSearch = () => {
        if (!this.state.initializationDone && this.props.urlState.search.length > 0) {
            this.setState({
                search: this.props.urlState.search, initializationDone: true,
            })
        }
    }


    getValidationIDs = () => {
        let url = `/api/get_all_validation_id/`;
        post(url, querystring.stringify({user: parseInt(cookie.load('user_id'))}))
            .then(resp_data => {
                let data = resp_data['data']
                let ids = []
                for (let i = 0; i < data.length; i++) {
                    ids.push(data[i].id)
                }
                let op = ids.map((id, index) => <Option value={id} key={index}>{id}</Option>)
                this.setState({validationIds: op})
            })
    }

    changeDownloadUserId = (value) => {
        this.setState({
            download_user_id: value,
        })
    }

    downloadSummary = () => {
        const url = `/api/create_table/?validation_id=${this.props.match.params.id}&user_id=${this.state.download_user_id}`;
        axios.get(getStateAwareUrl(url), {responseType: 'blob', headers: {Authorization: AuthHeader()}}).then(res => {
            window.open(URL.createObjectURL(res.data));
        })
    }

    render() {

        let all_users = this.state.all_users;
        let all_users_options = []
        for (let i = 0; i < all_users?.length; i++) {
            all_users_options.push(<Select.Option key={i}
                                                  value={all_users[i]['id']}>{all_users[i]['username']}</Select.Option>)
        }

        let initial_username = cookie.loadAll().username;
        for (let i = 0; i < all_users.length; i++) {
            if (parseInt(all_users[i].id) === parseInt(this.state.download_user_id)) {
                initial_username = all_users[i].username;
                break;
            }
        }

        this.initializeSearch();

        let toshowValidations = this.state.validatonSummary;

        return (<div className={"full-parent all-slides"}>
            <Spin tip="Loading..." spinning={this.props.isFetching} delay={500}>
                {this.props.isFetching === true ? <div></div> :
                    <Row>
                        <Col span={24} offset={0}>
                            <Row>
                                <Title> {this.state.validationName} </Title>
                            </Row>
                            <Row>
                                <h1>PATHOLOGIST AGREEMENT SUMMARY</h1>
                                <Table
                                    className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header"
                                    dataSource={this.state.pathologistSummary}
                                    size="small"
                                    bordered
                                >
                                    <Column title="PATHOLOGIST" span={1} dataIndex="user"/>
                                    <Column title="% CASES IN AGREEMENT" span={1} dataIndex="percentage"/>
                                    <Column title="TOTAL CASES" span={1} dataIndex="total"/>
                                </Table>
                            </Row>
                            <Row>
                                {this.state.all_users.length > 0 ? <div>
                                    <Row>
                                        <h2>DOWNLOAD SUMMARY</h2>
                                        {this.is_clia_staff && <Form.Item style={{width: '500px'}}>
                                            <Select onChange={this.changeDownloadUserId}
                                                    value={initial_username}
                                                    style={{width: '200px'}}>
                                                {all_users_options}
                                            </Select>
                                            <Button onClick={this.downloadSummary}
                                                    style={{marginLeft: '20px'}}>
                                                <DownloadOutlined/>
                                            </Button>
                                        </Form.Item>}
                                    </Row>
                                </div> : null}
                            </Row>
                            <Row>
                                <h1>VALIDATION SUMMARY</h1>

                                <Table
                                    className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header"
                                    dataSource={toshowValidations}
                                    size="small"
                                    style={{marginTop: '10px'}}
                                    bordered
                                >
                                    <Column title={getCaseIdPlaceholder()} span={1} dataIndex="case_id"/>
                                    <Column title="SLIDE" span={1} dataIndex="slide_name"/>
                                    <Column title="PATHOLOGIST" span={1} dataIndex="pathologist"/>
                                    <Column title="DATE OF CASE" span={1} dataIndex="date"/>
                                    <Column title="CASE TYPE" span={1} dataIndex="case_type"/>
                                    <Column title="POST-GLASS DIAGNOSIS" span={1}
                                            dataIndex="post_glass_diagnosis"/>
                                    <Column title="QUALITY OF SCAN" span={1} dataIndex="quality_of_scan"/>
                                    <Column title="DIAGNOSTIC CERTAINTY" span={1}
                                            dataIndex="diagnostic_certainty"/>
                                    <Column title="CONCORDANCE DESIGNATION" span={1}
                                            dataIndex="concordance_designation"/>
                                    <Column title="AGREE/DISAGREE" span={1} dataIndex="agree_disagree"/>

                                </Table>
                            </Row>
                        </Col>
                    </Row>}
            </Spin>

        </div>);
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        total: state.caseStatusReducer.total,
        urlState: state.searchCaseReducer,
        isFetching: state.searchCaseReducer.isFetching
    };
};

export default connect(mapStateToProps)(SummaryView);
